<template>
  <div>
    <div
    >
      <div
          v-if="screenShares.length > 0"
      >
        <ScreenShareGrid/>
      </div>

      <div style="flex: 1">
        <ResponsiveGrid
            :margin="16"
            :aspect-ratio="participantsAspectRatio"
            :tiles="[...participants, ...(nobodyElse ? [null] : [])]"
        >
          <template v-slot:tile="{ tile }">
            <div v-if="tile != null">
              A TILE
            </div>
            <waitingForOthers v-else></waitingForOthers>
          </template>
        </ResponsiveGrid>
      </div>
    </div>
  </div>
</template>

<script>
import Tile from "@/components/Tile";
import joinCall from "@/components/joinCall.vue";
import ScreenShareGrid from "@/components/ScreenShareGrid";
import waitingForOthers from "@/components/waitingForOthers.vue";
import ResponsiveGrid from "./ResponsiveGrid";

export default {
  name: "TileGrid",

  components: {
    ResponsiveGrid,
    Tile,
    joinCall,
    waitingForOthers,
    ScreenShareGrid,
  },

  data() {
    return {
      screenSize: {
        width: 0,
        height: 0,
      },
    };
  },

  watch: {
    participants(newVal) {
      console.log(newVal.length);
    },
  },

  methods: {
    onWindowResize() {
      this.screenSize = {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      };
    },
  },

  computed: {
    isJoinedMeeting() {
      return this.$store.getters.isJoinedMeeting
    },
    screenShares() {
      return [] //todo: expose screenshares
    },
    participantsAspectRatio() {
      if (this.screenSize.width <= 769) {
        return this.screenShares.length > 0 ? 1 : 10 / 16;
      } else {
        return 4 / 3;
      }
    },
    nobodyElse() {
      return (
          this.meetingState === "joined-meeting" &&
          this.$store.state.meeting.participants.length === 1 &&
          this.screenShares.length === 0
      );
    },
    participants() {
      return this.$store.state.meeting.participants.map((participant) => ({
        userId: participant.user_id,
        name: participant.user_name,
        isLocal: participant.local,
        video: participant.tracks.video,
        audio: participant.tracks.audio,
      }));
    },
  },

  mounted() {
    this.onWindowResize();
    window.addEventListener("resize", this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
  },
};
</script>

<style lang="scss">
.call_area_wrap {
  flex-wrap: wrap;
  width: 100%;
  grid-gap: 16px;
  flex: 1 1 auto;

  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;

  @media all and (max-width: 767px) {
    height: auto;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr;
    max-height: calc(100% - 134px);
  }

  &.screencast {
    grid-template-columns: 1fr 320px;
    column-gap: 16px;
    height: auto;

    .call_area {
      order: 2;
      border-radius: 16px;

      .screen_cast {
        z-index: 0;

        img {
          width: 100%;
          height: 100%;
          min-height: 100%;
          min-width: 100%;
          object-position: center;
          object-fit: cover;
        }
      }

      &.screen {
        height: calc(100% - 82px);

        .screen_cast {
          max-height: 100%;
          max-width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border-radius: 16px;
        }

        video {
          object-fit: contain;
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          transform: scaleX(1);
        }

        & ~ .call_area:nth-child(n + 3) {
          display: none;
        }
      }

      &:not(.screen) {
        height: 320px;
        overflow: hidden;
        align-self: center;
      }
    }
  }

  .text_overlay {
    border-radius: 16px;
    background-color: #000;
    position: absolute;
    z-index: 3;
    left: 32px;
    bottom: 32px;
    right: 32px;
    text-align: center;
    padding: 20px;
    color: #fff;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}

.meeting-grid {
  flex: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  &.has-screenshare {
    grid-template-columns: 2fr 1fr;

    @media all and (max-width: 767px) {
      grid-template-columns: unset;
      grid-template-rows: 2.5fr 1fr;
    }
  }
}
</style>
